import { EventWithRelationsImpl } from '../implements/event-with-relations.impl';

export class GetEventsByIdResponseDto extends EventWithRelationsImpl {}
